module.exports = __webpack_public_path__ + "static/media/Nexity-Regular.caaa9f11.ttf";